export const AnimatedDivider = () => (
  <div className="bubble-divider" aria-hidden="true">
    <span />
    <span />
    <span />
    <span />
    <span />
    <span />
    <span />
  </div>
);
